import { RichText } from 'prismic-reactjs';

export function getRichTextAsText(t: any, key: string): string {
  const raw = t(key, { returnObjects: true });
  return Array.isArray(raw)
    ? RichText.asText(raw)
    : String(raw);
}

export function getRichTextRendered(t: any, key: string) {
  const raw = t(key, { returnObjects: true });
  return Array.isArray(raw)
    ? RichText.render(raw)
    : String(raw);
}